<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style=" padding:0; margin:20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
          </el-button>
      </el-col>
    </el-row>
    
    <el-form
      :model="activity"
      status-icon
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >

      <el-form-item label="类型">
        <label slot="label"><span style="color:red">*</span>类型</label>
        <el-radio-group v-model="activity.meet_type" @change="typeChange">
          <el-radio :label="1" :disabled="!this.create">心理公开课</el-radio>
          <el-radio :label="2" :disabled="!this.create">幸福之旅</el-radio>
          <el-radio :label="3" :disabled="!this.create">发光者活动</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="标题" prop="title">
        <label slot="label"><span style="color:red">*</span>标题</label>
        <el-input v-model="activity.title" placeholder="请输入标题"></el-input>
      </el-form-item>

      <el-form-item label="核销代理商" v-if="is_show == 1">
        <label slot="label"><span style="color:red">*</span>核销代理商</label>
        <el-select
            class="search-el"
            v-model="activity.agent_id"
            placeholder="请选择核销代理商"
            clearable
            filterable
        >
          <el-option label="请选择核销代理商" value=""></el-option>
          <el-option
              v-for="item in agentList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="分润百分比" prop="number" v-if="is_show == 1">
        <label slot="label"><span style="color:red">*</span>分润百分比</label>
        <el-input
            v-model.number="activity.share_ratio"
            type="number"
            min="0"
            @keydown.native="handleInputDown"
            @input="handleInput"
            :max="100"
            style="width:16%"
        ><template slot="suffix">%</template></el-input>
      </el-form-item>


      <el-form-item label="开始时间">
        <label slot="label"><span style="color:red">*</span>开始时间</label>
        <el-date-picker
          v-model="activity.start_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择开始时间"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="activity.end_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          default-time="23:59:59"
          placeholder="选择结束时间"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="活动详情">
        <tinymce v-model="activity.content"></tinymce>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="create == true ? createMeetActivity() : updateMeetActivity()"
          :loading="updateLoading"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import tinymce from '@/components/tinymce.vue';
import { getAllAgent } from "@/api/agent";

import {
  createMeetActivity,
  updateMeetActivity,
  getMeetActivityInfo,
} from "@/api/activity";

export default {
  data: function () {
    return {
      create: true,
      updateLoading: false,
      agentList: [],
      activity: {
        id: 0,
        title: "",
        img_url: "",
        content: "",
        start_at: "",
        end_at: "",
        meet_type: 1,
        share_ratio: '',
        agent_id: '',
      },
      is_show: 0,
    };
  },
  components: {
    tinymce,
  },
  created: function () {
    getAllAgent().then((res) => {
      if (res.status === "2000") {
        this.agentList = res.data.list;
      }
    });
    this.activity.id = this.$route.query.id;
    if (this.activity.id > 0) {
      this.create = false;
      this.getMeetActivityInfo();
    }
  },
  mounted() {
  },
  methods: {
    handleInputDown(e) {
      let key = e.key
      console.log(key)
      // 不允许输入'.'
      if (key === '-' || key === '.' || key === '。') {
        e.returnValue = false
        return false
      }
    },
    handleInput(value) {
      if (value > 100) {
        this.activity.share_ratio = 100;
      }
      if (value < 0) {
        this.activity.share_ratio = '';
      }
    },
    typeChange(val) {
      console.log(val)
      if (val == 1 || val== 3) {
        this.is_show = 0
      } else {
        this.is_show = 1
      }
    },

    createMeetActivity() {
      if (this.activity.title == '') {
        this.$message.error('标题不能为空')
        return false
      }
      if (this.activity.meet_type == 2 && this.activity.agent_id == '') {
        this.$message.error('核销代理商不能为空')
        return false
      }

      if (this.activity.meet_type == 2 && this.activity.share_ratio === '') {
        this.$message.error('分润百分比不能为空')
        return false
      }

      this.updateLoading = true;
      createMeetActivity(this.activity)
        .then((response) => {
          this.updateLoading = false;
          if (response.status == 2000) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/activity/meetList",
            });
            this.dialogVisible = false;
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },
    updateMeetActivity() {
      if (this.activity.meet_type == 2 && this.activity.agent_id == '') {
        this.$message.error('核销代理商不能为空')
        return false
      }

      if (this.activity.meet_type == 2 && this.activity.share_ratio === '') {
        this.$message.error('分润百分比不能为空')
        return false
      }
      this.updateLoading = true;
      updateMeetActivity(this.activity)
        .then((response) => {
          this.updateLoading = false;
          if (response.status == 2000) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/activity/meetList",
            });
            this.dialogVisible = false;
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },
    getMeetActivityInfo() {
      this.loading = true;
      getMeetActivityInfo({
        id: this.activity.id,
      }).then((response) => {
        this.activity = {
          id: response.data.id,
          title: response.data.name,
          img_url: "",
          content: response.data.content,
          start_at: response.data.start_at,
          end_at: response.data.end_at,
          meet_type: response.data.meet_type,
          share_ratio: response.data.share_ratio,
          agent_id: response.data.agent_id,
        };
        if (this.activity.meet_type == 2) {
          this.is_show = 1;
        }
        this.loading = false;
      });
    },
  },
};
</script>